import MuiInput from '../../../../components/material-ui/muiInput';
import RequestButton from '../../../../components/requestButton';
import style from './style.css';
import { getNumericValue } from '../../../../utils/stringOperations';
import actionType from '../../../../actions/ntbAction/actionType';

const MobileInput = (props) => {
  const {
    pageKey,
    mobileNo,
    merchantId,
    onChange,
    ntbAction,
    channel,
    variant,
  } = props || {};
  return (
    <div className={style.campaignEnterMobileInputContainer}>
      <span className={`${style.mobileNoPrefix}`}>+91</span>
      <MuiInput
        inputID='topMobile'
        inputPlaceholder='Enter your mobile number'
        pageKey={pageKey}
        maxLength={10}
        minLength={10}
        inputValue={mobileNo}
        inputType='tel'
        className={`font14 ${style.campaignEnterInputBoxMobile}`}
        onChange={(e) => {
          const mobileNo = getNumericValue(e.target.value);
          return onChange(mobileNo);
        }}
        elementName='ap_enter_mobile'
        variant={variant}
      />
      <RequestButton
        buttonDisabled={mobileNo.length !== 10}
        buttonId='eligibility-button'
        loadingMsg='Verifying...'
        pageKey={pageKey}
        elementName='ap_check_pa_status_btn'
        buttonWrapperClass={`font14 ${style.campaignEnterMobileSubmitButton}`}
        buttonText='Send OTP'
        buttonOnClick={() => {
          return ntbAction(actionType.sendOTP, {
            mobile: mobileNo,
            merchantId,
            channel,
          });
        }}
        requestStatus={false}
        variant={variant}
      />
      <div className={style.otpText}>*We will send you one time password (OTP)</div>
    </div>
  );
};

export default MobileInput;



// WEBPACK FOOTER //
// ./routes/campaign-fast-feature/components/mobile-input/index.js